import type { User } from '../userTypes';

/**
 * True when the account has never signed in (HOMCO-1393): the password-link
 * action then (re)sends the activation link instead of resetting a password the
 * user never chose. Same criterion as the backend's e-mail template choice.
 */
export function isAwaitingActivation(user: Pick<User, 'last_login_at'>): boolean {
  return user.last_login_at === null;
}
